import { useEffect, useState } from "react";
import { ContentSpace } from "../_components";
import { User } from "../_modelsTS/User";
import { UserConfigView } from "./UserConfigView";
import { UsersListView } from "./UsersListView";
import { useDispatch, useSelector } from "react-redux";
import { locationActions } from "../_actions";
import { Selectors } from "../_reducers/app.reducer";

export function UsersModule() {
    const dispatch = useDispatch();
    const locationUid = useSelector(Selectors.getInvitationSelectedUid);
    const users: User[] = useSelector(Selectors.getUsers);
    const [selectedUserUid, setSelectedUserUid] = useState<string | null>(null);
    const [isRefreshing, setIsRefreshing] = useState(false);

    useEffect(() => {
        dispatch(locationActions.getLocationUsers(locationUid))
    }, [dispatch, locationUid])

    function onUserConfigUpdate(selectedUser) {
        setIsRefreshing(true);

        dispatch(locationActions.getLocationUsers(locationUid));
    }

    const onSelectUser = (user: User) => {
        setSelectedUserUid(user.uid);
    };

    useEffect(() => {
        if (isRefreshing) {
            setIsRefreshing(false);
            
            if (selectedUserUid) {
                 // Setting state again forces the entire re-render logic to run 
                 // and pick up the new user object from the fresh `users` array.
                 setSelectedUserUid(selectedUserUid);
            }
        }
    }, [users, isRefreshing, selectedUserUid]); // Depend on users and the flag

    const currentDetailedUser = users.find(u => u.uid === selectedUserUid) || null;

    const detailedContent = currentDetailedUser ? (
        <UserConfigView 
            // Pass the user object. This prop will change when 'selectedUser' state changes.
            user={currentDetailedUser} 
            onUpdate={onUserConfigUpdate}
        />
    ) : null;

    return (
        <ContentSpace
            mainContent={<UsersListView users={users} onSelectUser={onSelectUser} />}
            onGoBack={() => {
                setSelectedUserUid(null);
            }}
            detailedContent={detailedContent}
        />
    );
}
